export default __webpack_public_path__ + "static/media/banner-page.ec712eb8.png";